/* Premier Catering Supplies — homepage "Featured ranges" cards: qty stepper + AJAX add to basket (26-9-2026).
   One request per card at a time; dispatches cart:update / cart:refresh so the header basket count refreshes. */
(function () {
  'use strict';
  var root = document.querySelector('.pfr');
  if (!root) return;
  function clamp(n) { n = parseInt(n, 10); if (isNaN(n) || n < 1) n = 1; if (n > 999) n = 999; return n; }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pfr-step]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    if (!input) return;
    input.value = clamp(clamp(input.value) + parseInt(b.getAttribute('data-pfr-step'), 10));
  });
  root.addEventListener('change', function (e) {
    if (e.target.matches('.pfr-qty input')) e.target.value = clamp(e.target.value);
  });
  root.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-pfr-buy]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('.pfr-card__add');
    if (!btn || btn.classList.contains('is-busy')) return;
    var label = btn.querySelector('span');
    var input = form.querySelector('input[name="quantity"]');
    var qty = clamp(input && input.value);
    if (input) input.value = qty;
    var id = parseInt(form.querySelector('input[name="id"]').value, 10);
    btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding…';
    var done = function (cls, text) {
      btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy');
      btn.classList.add(cls);
      if (label) label.textContent = text;
      setTimeout(function () { btn.classList.remove(cls); if (label) label.textContent = 'Add to basket'; }, 2400);
    };
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: id, quantity: qty }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { done('is-error', res.body && res.body.description ? 'Not added — try again' : 'Try again'); return; }
        done('is-done', 'Added ✓');
        document.dispatchEvent(new CustomEvent('cart:update', { detail: { source: 'pch-featured' } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'pch-featured' } }));
      })
      .catch(function () { done('is-error', 'Try again'); });
  });
})();